import { AppProviders } from "@/providers/AppProviders";
import { AppRoutes } from "@/routes";
import { useDeployVersionCheck } from "@/hooks/useDeployVersionCheck";

export default function App() {
  useDeployVersionCheck();

  return (
    <AppProviders>
      <AppRoutes />
    </AppProviders>
  );
}
